
import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import api from '../../../utils/api'

import EditCategory from '../EditCategory'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'


function ListCategoryRow({ dataArray, myPermissionView, myPermissionEdit, myPermissionDelete, handleOnSuccess }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    /* ------------------- Modal useState ----------------------*/

    const [modalEditCategory, setModalEditCategory] = useState(false)
    const [categoryId, setCategoryId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [categoryName, setCategoryName] = useState("")

    async function deleteCategory(id) {
        let msgType = 'success'
        const data = await api.delete(`/category/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    /* ------------------------ cards ------------------------------ */
    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                <div key={item._id} className='pg-item'>
                    <div className='pg-item-main'>
                        <span className='pg-item-name'>{item.name}</span>
                    </div>

                    <div className='shd-row-box-item-action'>
                        {myPermissionEdit &&
                            <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={() => { setCategoryId(item._id); setModalEditCategory(true) }} />
                        }
                        {myPermissionDelete &&
                            <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={() => { setModalDeleteItem(true); setCategoryId(item._id); setCategoryName(item.name) }} />
                        }
                    </div>
                </div>
            ))
        }
    }

    return (
        <div>
            {listArray()}

            <Modal
                modalStatus={modalEditCategory}
                changeStatus={setModalEditCategory}
                w={82}
                content={
                    <EditCategory id={categoryId} handleOnSuccess={() => { setModalEditCategory(false); handleOnSuccess() }} btCancelAction={() => setModalEditCategory(false)} />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteCategory(categoryId)}
                message="Deseja realmente excluir essa categoria?"
                itemName={categoryName}
            />

        </div>
    )
}

export default ListCategoryRow
